module.exports = __webpack_public_path__ + "static/ballantinesEF-eb8b679abae05cbb2a1c5e512a84fc14.ttf";